import { SideNavigation } from './SideNavigation';

export default SideNavigation;
